import { z } from 'zod';

import { Address } from '../Address';
import { PropertyId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';
import { NonNegativeMonetaryValue } from '../validations/fields';
import { AppraisalInput } from './Appraisal';

export const PropertyFlood = z.object({
  zone: z.string().optional(),
  zoneFlag: z.boolean().optional(),
  partialZoneIndicator: z.string().optional(),
  contractType: z.string().optional(),
  contractNumber: z.string().optional(),
  program: z.string().optional(),
  nfipDateRevisionType: z.string().optional(),
  nfipCommunityIdentifier: z.string().optional(),
  nfipMapIdentifier: z.string().optional(),
  nfipMapPanelDate: zodJSPlainDate.optional(),
  certificateProviderName: z.string().optional(),
  certificateNumber: z.string().optional(),
  determinationDate: zodJSPlainDate.optional(),
});
export type PropertyFlood = z.infer<typeof PropertyFlood>;

/**
 * Contracts that will be transferred to the next servicer
 */
export const TransferableMonitoringContracts = z.object({
  flood: z.boolean().optional(),
  tax: z.boolean().optional(),
});
export type TransferableMonitoringContracts = z.infer<typeof TransferableMonitoringContracts>;

export const Property = z.object({
  id: PropertyId,
  address: Address,
  isReleased: z.boolean(),
  coverageAmount: NonNegativeMonetaryValue.optional(),
  replacementCostValue: NonNegativeMonetaryValue.optional(),
  propertyType: z.string().optional(),
  propertySubType: z.string().optional(),
  flood: PropertyFlood.optional(),
  purchasePrice: NonNegativeMonetaryValue.optional(),
  numberOfUnits: z.int().positive().optional(),
  targetAreaProperty: z.boolean().optional(), // located in a designated area where governments or housing finance agencies offer more favorable mortgage terms to encourage homeownership or investment
  propertyValuationMethodType: z.string().optional(),
  transferableMonitoringContracts: TransferableMonitoringContracts.optional(),
});

export type Property = z.infer<typeof Property>;

export const PropertyInput = Property.omit({ id: true, isReleased: true }).extend({
  appraisal: AppraisalInput.optional(),
  originalAppraisal: AppraisalInput.optional(),
});
export type PropertyInput = z.infer<typeof PropertyInput>;
